import styled from 'styled-components'
import { Icon } from '@navent-jobs/ui-kit/components/icon'

export const InformationBox = styled.div`
  background: ${({ theme }) => theme.colors.grey0};
  border-radius: 8px;
  padding: 16px;
  margin: 0px 0px 20px;
`

export const InformationList = styled.ul`
  display: inline-block;
  padding: 0px;
  margin: 16px 0px 0px 0px;
  line-height: 16px;
`

export const InformationItem = styled.li`
  display: flex;
  align-items: center;
  align-content: flex-start;
  padding: 0px;
  text-decoration: none;
  word-break: break-word;
  margin: 0px 0px 16px 0px;
  &:last-child {
    margin-bottom: 0px;
  }
`

export const InformationlIcon = styled(Icon)`
  display: flex;
  align-self: center;
  margin: 0px 8px 0px 0px;
`

